import { render, staticRenderFns } from "./DesktopSubArticle.vue?vue&type=template&id=65123742&"
import script from "./DesktopSubArticle.vue?vue&type=script&lang=js&"
export * from "./DesktopSubArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports